import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Rat extends Mob {
	constructor(sprites, infoable = true) {
		super(sprites, StandardSheetAnimations.getAnimation("rat"), Rat.WALK_STEP * Game.MULT, Rat.RADIUS);
		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;
		this.substAnimation("idle_e", 1, { row: 9, col: 0 });
		this.substAnimation("idle_w", 1, { row: 9, col: 0 });
		this.substAnimation("idle_n", 1, { row: 10, col: 0 });


		let traits = {
			clas: "enemy",
			race: "rat",
			openDoors: false,
			static: false,
			qi: BasicAI.QI_LOW,
			speed: Rat.WALK_STEP * Game.MULT,
			radius: Rat.RADIUS,
			runspeed: Rat.RUN_STEP * Game.MULT,
			timeWarns: Rat.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Rat.RADIUS = 4;
Rat.WALK_STEP = 3;
Rat.RUN_STEP = 4;
Rat.TIME_WARNS = [250, 350];